import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }

import { ref, watch } from 'vue'
import BaseModal from '@/components/ui/BaseModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MetaPromptModal',
  props: {
    show: { type: Boolean },
    metaPrompt: {}
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isOpen = ref(props.show)
const localMetaPrompt = ref(props.metaPrompt || '')

watch(() => props.show, (newShow) => {
  isOpen.value = newShow
  if (newShow) {
    localMetaPrompt.value = props.metaPrompt || ''
  }
})

const handleModelUpdate = (value: boolean) => {
  if (!value) {
    handleClose()
  }
}

const handleClose = () => {
  isOpen.value = false
  emit('close')
}

const handleSave = () => {
  emit('save', localMetaPrompt.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => ((isOpen).value = $event)),
      handleModelUpdate
    ]
  }, {
    title: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "text-center" }, "Add Additional Information", -1)
    ])),
    footer: _withCtx(() => [
      _createElementVNode("div", { class: "flex justify-end gap-3" }, [
        _createElementVNode("button", {
          type: "button",
          class: "rounded-lg border border-gray-700 px-4 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700/50",
          onClick: handleClose
        }, " Cancel "),
        _createElementVNode("button", {
          type: "button",
          class: "rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-dark",
          onClick: handleSave
        }, " Save ")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("textarea", {
            id: "metaPrompt",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localMetaPrompt).value = $event)),
            rows: "4",
            class: "mt-1 block w-full rounded-lg border border-gray-700 bg-dark px-3 py-2 text-sm text-gray-100 placeholder-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary",
            placeholder: "Enter additional information about this product..."
          }, null, 512), [
            [_vModelText, localMetaPrompt.value]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})